import type { CostVersusOutputMeasures } from '../../store/financials-store/financials-store.type';
import { graphLightRed, graphPictonBlue, graphSandyBrown, graphTropicalIndigo } from '../../styles/design-tokens';

export const DEFAULT_CHART_COLORS = [graphTropicalIndigo, graphLightRed, graphPictonBlue, graphSandyBrown];

const COST_VERSUS_OUTPUT_MEASURES: CostVersusOutputMeasures[] = [
  'cost',
  'daily_burn',
  'cost_per_point',
  'cost_per_task',
  'committed_points',
  'completed_points',
  'committed_tasks',
  'completed_tasks',
];

const INITIAL_COST_VERSUS_OUTPUT_MEASURES = [
  'daily_burn',
  'committed_tasks',
  'completed_tasks',
  'cost_per_task',
] as CostVersusOutputMeasures[];

const INITIAL_ALLOCATION_OF_COSTS_MEASURE = 'assignee' as const;

const MAX_SELECTED_FILTERS = 4;

export {
  COST_VERSUS_OUTPUT_MEASURES,
  INITIAL_ALLOCATION_OF_COSTS_MEASURE,
  INITIAL_COST_VERSUS_OUTPUT_MEASURES,
  MAX_SELECTED_FILTERS,
};
